import { object } from "prop-types";
const OPEN_MODAL = "OPEN_MODAL";
const CLOSE_MODAL="CLOSE_MODAL";
const MODAL_MANAGE="manage";
const MODAL_MANAGE_PEOPLE="managePeople";
const MODAL_ALERT="alert";
const MODAL_HOME="home";
const MODAL_CLASSDATA="classdata";
const MODAL_RANKINGLIST="rankingList";
const MODAL_STUDENTINFO="studentinfo";
const MODAL_ACTIVITYLIST="activityList";
const MODAL_ACTIVITYDETAIL="activityDetail";
const MODAL_DONGTAIDETAIL="dongtaiDetail";
const MODAL_VERSION="versionUpdate";
const MODAL_ZIPINGLIST="zipingList";
const MODAL_ACTIVITYSHENHE="activityShenhe";
const MODAL_TERMREPORT="activityTermreport";

const initialState = {
    [MODAL_MANAGE]:true,
    [MODAL_MANAGE_PEOPLE]:false,
    [MODAL_ALERT]:false,
    [MODAL_HOME]:false,
    [MODAL_CLASSDATA]:false,
    [MODAL_RANKINGLIST]:false,
    [MODAL_STUDENTINFO]:false,
    [MODAL_ACTIVITYLIST]:false,
    [MODAL_ACTIVITYDETAIL]:false,
    [MODAL_DONGTAIDETAIL]:false,
    [MODAL_VERSION]:false,
    [MODAL_ZIPINGLIST]:false,
    [MODAL_ACTIVITYSHENHE]:false,
    [MODAL_TERMREPORT]:false
}
const reducer = function(state = initialState, action) {
    let { type } = action;
    switch (type) {
        case OPEN_MODAL:return Object.assign({},state,{
            [action.modal]:true
        })
        case CLOSE_MODAL:return Object.assign({},state,{
            [action.modal]:false
        })
        default: return state;
    }
}

export {
    reducer as default,
    initialState as modalsInitialState
}
